import React from "react";
import PropTypes from "prop-types";
import MenuContent from "./menu/menu-content";
import MenuIcon from "./menu/menu-icon";
import MenuWrapper from "./menu/menu-wrapper";

const DashboardMenu = ({ className, onDrawerClose, open }) => (
  <MenuWrapper className={className} open={open}>
    <MenuIcon onClick={onDrawerClose} />
    <MenuContent className={className} />
  </MenuWrapper>
);

DashboardMenu.propTypes = {
  /**
   * Indica si el menú lateral del dashboard está desplegado
   **/
  open: PropTypes.bool,
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Handler que se llama cuando se cierra el dashboard
   **/
  onDrawerClose: PropTypes.func,
};

export default DashboardMenu;
